var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49377 4.95575V9.80826H3.89495V4.95575H4.49377ZM3.56456 0H8.35512C8.95394 0 9.11914 0.454277 9.11914 0.970501H11.4938C12.0513 0.970501 12.0719 2.16814 11.4938 2.16814H11.0395V11.8319C11.0395 13.0295 10.069 14 8.87135 14H3.04834C1.8507 14 0.880197 13.0295 0.880197 11.8319V2.16814H0.42592C-0.152251 2.16814 -0.131602 0.970501 0.42592 0.970501H2.80055C2.80055 0.474926 2.98639 0 3.56456 0ZM8.35512 0.59882H3.56456C3.35807 0.59882 3.39937 0.825959 3.39937 0.949853H8.52032C8.52032 0.80531 8.56161 0.59882 8.35512 0.59882ZM10.0277 2.14749H1.91265V11.8112C1.91265 12.4513 2.42887 12.9676 3.06899 12.9676H8.892C9.53211 12.9676 10.0483 12.4513 10.0483 11.8112V2.14749H10.0277ZM6.26958 3.94395V10.7994H5.67076V3.94395H6.26958ZM8.02474 4.95575V9.80826H7.42592V4.95575H8.02474Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a2e004fd6d15a864f12397603cfc101b.svg";
export { ForwardRef as ReactComponent };